import { transformPromptDtoToModel } from '../prompt/mappers';
import { hiddenCategoryIds } from '../../../data/categories';
import { SearchResponse, SearchResponseDto } from './types';

export const transformPromptsDtoToCards = (response: SearchResponseDto): SearchResponse => {
    // Фильтруем промпты, исключая те, что содержат скрытые категории
    const filteredResponse = response.filter(prompt => {
        // Проверяем, что промпт не в скрытых категориях
        return !prompt.categories.every(category => hiddenCategoryIds.includes(category));
    });

    return filteredResponse.map(transformPromptDtoToModel);
};
